module.exports = __webpack_public_path__ + "media/game_over.6424c963.mp4";